<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<!--<span class="cc-header">-->
<!--  <span class="cc-title">-->
<!--    {{'page.' + this.transPartKey + '.title' | translate}}-->
<!--  </span>-->
<!--</span>-->
<mat-tab-group *ngIf="desks"
               class="tradesOrdersContainer" [(selectedIndex)]="selectedViewIndex"
               (selectedIndexChange)="viewChanged($event)"
               animationDuration="800ms">
  <mat-tab *ngFor="let desk of desks; trackBy: trackByDesk">
    <ng-template mat-tab-label>
      <span class="mat-tab-label-content">
<!--      <mat-icon></mat-icon>-->
        {{desk}}</span>
    </ng-template>
    <ng-template matTabContent>
      <app-list-e-ticket [desk]="desk"></app-list-e-ticket>
    </ng-template>
  </mat-tab>
</mat-tab-group>
